import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';
import { increaseQuizCount } from '~teacher/hook/useQuizLimit';
import { quizzesQueryKey } from '~teacher/hook/useQuizzes';

import {
  CreateQuizParameter,
  CreateQuizResponse,
  createQuiz,
} from '../../api/quiz';

type Error = unknown;
type Context = unknown;

export function useCreateQuizMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createQuiz,
    mutationKey: ['quizzes', 'create'],
    onSuccess: () => {
      // Don't show toast in this scenario
      increaseQuizCount(queryClient);
    },
    onError: (error) => {
      apiToaster([], QuizToastActions.CREATE_QUIZ, error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(quizzesQueryKey.quiz);
    },
  });
}

export type CreateQuizMutationFunction = UseMutateFunction<
  CreateQuizResponse,
  Error,
  CreateQuizParameter,
  Context
>;
